export interface SurveyLogsProps {
    historical?: any[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    // Survey fields
    code: 'Código',
    title: 'Título',
    description: 'Descripción',
    status: 'Estado',

    // Question fields
    type: 'Tipo de Pregunta',
    subtype: 'Subtipo',
    icon: 'Icono',
    why: '¿Por qué?',
    required: 'Requerida',
    dependency: 'Tiene Dependencia',
    position: 'Posición',
    isOrDependencies: 'Dependencias OR',

    // Answer fields
    label: 'Etiqueta',
    range: 'Rango',
};

export const typeLabels: { [key: string]: string } = {
    survey: 'Encuesta',
    question: 'Pregunta',
    answer: 'Respuesta',
};
